<template lang='pug'>
  b-nav-item-dropdown(right='', no-caret='')
    template(slot='button-content')
      img.img-avatar(src='static/img/avatars/6.jpg', alt='admin@bootstrapmaster.com')
    b-dropdown-header.text-center(tag='div')
      strong Account
    b-dropdown-item
      i.fa.fa-bell-o
      |  Updates
      b-badge(variant='info') {{itemsCount}}
    b-dropdown-item
      i.fa.fa-envelope-o
      |  Messages
      b-badge(variant='success') {{itemsCount}}
    b-dropdown-item
      i.fa.fa-tasks
      |  Tasks
      b-badge(variant='danger') {{itemsCount}}
    b-dropdown-item
      i.fa.fa-comments
      |  Comments
      b-badge(variant='warning') {{itemsCount}}
    b-dropdown-header.text-center(tag='div')
      strong Settings
    b-dropdown-item
      i.fa.fa-user
      |  Profile
    b-dropdown-item
      i.fa.fa-wrench
      |  Settings
    b-dropdown-item
      i.fa.fa-usd
      |  Payments
      b-badge(variant='light') {{itemsCount}}
    b-dropdown-item
      i.fa.fa-file
      |  Projects
      b-badge(variant='primary') {{itemsCount}}
    b-dropdown-divider
    b-dropdown-item
      i.fa.fa-shield
      |  Lock Account
    b-dropdown-item
      i.fa.fa-lock
      |  Logout
</template>
<script>
  export default {
    name: 'header-dropdown-accnt',
    data: () => {
      return { itemsCount: 42 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue